import { OrderRepository } from "../Repository/OrderRepository";


export interface UpdateDeliveryDateUseCase {
  invoke: (data: any) => Promise<boolean>;
}

export class UpdateDeliveryDate implements UpdateDeliveryDateUseCase {
  private repo: OrderRepository;
  constructor(_Repo: OrderRepository) {
    this.repo = _Repo;
  }

   invoke(data: any){
    if(!data){
        throw new Error(
            "No tiene la data necesaria."
          );
    }
    const getData = this.repo.updateDeliveryDate(data);
    return getData;
  }
}